<script setup>
import { computed } from 'vue'
// props
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  disalbed:{
    type : Boolean,
    default : false
  }
})

// computed
const displayModelValue = computed(() => {
  const item = props.options.find(item => item.value === props.modelValue)
  return item?.text || ''
})

// emit
const emit = defineEmits(['update:modelValue', 'selectClick'])

// methods
function selectItem(item, event) {
  emit('update:modelValue', item)
  emit('selectClick', item, event)
}
</script>

<template>
  <div class="dropdown">
    <ElButton
      type="dropdown"
    >
      {{ displayModelValue }}
    </ElButton>
    <ul class="dropdown-menu" v-show="!props.disalbed">
      <li v-for="(item, index) in options" :key="`${item.value}${index}`">
        <a
          class="dropdown-item"
          @click="(e) => selectItem(item.value, e)"
          >{{ item.text }}</a
        >
      </li>
    </ul>
  </div>
</template>

<style scoped>
.dropdown .form-select {
  min-height: 30px;
}
.dropdown-menu { 
  max-height: 200px; /* 최대 높이 설정 */ 
  overflow-y: auto; /* 스크롤 설정 */ 
  border: 1px solid #ccc; /* 시각적 구분을 위한 테두리 */ 
  padding: 0; /* 기본 패딩 제거 */ list-style: none; /* 리스트 스타일 제거 */ 
} 
.dropdown-item { 
  padding: 10px; 
  cursor: pointer; 
  display: block; 
  text-decoration: none; 
  color: #333; 
} 
.dropdown-item:hover { 
  background-color: #f0f0f0; 
}
</style>